module.exports = __webpack_public_path__ + "static/media/KMH_5331.8edd59ea.jpg";